<template>
  <div class="home">
    <b-img :src="require('../assets/sioLogo.png')" fluid alt="Responsive image" />
    <b-button to="/register" size="lg" variant="default" class="sign-up">I'm new - Sign me up</b-button>
    <b-button to="/login" size="lg" variant="light" class="login">I'm already registered</b-button>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'home',
  components: {

  }
}
</script>

<style>
  .home {
    background-image: url('../assets/raffey_launch.jpg') !important;
    background: no-repeat;
    background-position: center !important;
    min-height:100vh;
    max-width: 100vw;
    position: relative;
  }

  .sign-up {
    position: relative;
    top: 60vh;
    width: 95%;
    text-align: center;
    margin-left: 10px;
    margin-right: 10px;
  }

  .login {
    top: 63vh;
    position: relative;
    width: 95%;
    text-align: center;
    margin-left: 10px;
    margin-right: 10px;
  }
</style>
